import { __ } from "@wordpress/i18n";
import {
    Plus,
    Minus,
    ChevronUp,
    ChevronDown,
    ChevronRight,
    ChevronLeft,
    ArrowDown,
    ArrowUp,
    ArrowRight,
    ArrowLeft,
} from "lucide-react";
import { useSettingsContext } from "../../../hook/useSettingsContext";
import QuantityButton from "./QuantityButton";
import QuantityInput from "./QuantityInput";
import { customStyleVariables } from "../../../others/customStyleVariables";
import QuantitySlider from "./QuantitySlider";
import QuantityAlert from "./QuantityAlert";

// Icon configuration map
const ICON_MAP = {
    plus_minus: {
        horizontal: { inc: Plus, dec: Minus },
        vertical: { inc: Plus, dec: Minus },
    },
    arrows: {
        horizontal: { inc: ArrowRight, dec: ArrowLeft },
        vertical: { inc: ArrowUp, dec: ArrowDown },
    },
    chevrons: {
        horizontal: { inc: ChevronRight, dec: ChevronLeft },
        vertical: { inc: ChevronUp, dec: ChevronDown },
    },
};

export default function Preview() {
    const { getOption } = useSettingsContext();

    const btnSkin = getOption("btnSkin", "general");
    const qtyDisplayType = getOption("qtyDisplayType", "general");
    const iconsType = getOption("iconsType", "icon"); // plus_minus, arrows, chevrons
    const prefixText = getOption("prefixText", "prefixsuffix");
    const suffixText = getOption("suffixText", "prefixsuffix");
    const isVertical = btnSkin === "type4" || btnSkin === "type5";
    const quantityStyle = customStyleVariables();

    // Get icons based on type and orientation
    const orientation = isVertical ? "vertical" : "horizontal";
    const icons =
        ICON_MAP[iconsType]?.[orientation] || ICON_MAP.plus_minus[orientation];
    const IncIcon = icons.inc;
    const DecIcon = icons.dec;

    return (
        <>
            <QuantityAlert />

            <div
                className={`wpb-pmqb-quantity-preview quantity-skin-${btnSkin}`}
                style={quantityStyle}
            >
                <>
                    {prefixText && (
                        <div className="wpb-pmqb-quantity-prefix">
                            {prefixText}
                        </div>
                    )}

                    {qtyDisplayType === "buttons" && (
                        <div className="quantity wpb-pmqb-quantity">
                            {isVertical ? (
                                <>
                                    <QuantityInput />
                                    <div className="wpb-pmqb-qty-btns-wrapper">
                                        <QuantityButton type="plus">
                                            <IncIcon />
                                        </QuantityButton>
                                        <QuantityButton type="minus">
                                            <DecIcon />
                                        </QuantityButton>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <QuantityButton type="minus">
                                        <DecIcon />
                                    </QuantityButton>
                                    <QuantityInput />
                                    <QuantityButton type="plus">
                                        <IncIcon />
                                    </QuantityButton>
                                </>
                            )}
                        </div>
                    )}
                    {qtyDisplayType === "slider" && <QuantitySlider />}

                    {suffixText && (
                        <div className="wpb-pmqb-quantity-suffix">
                            {suffixText}
                        </div>
                    )}
                </>
            </div>
        </>
    );
}
